<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">スタッフマスタ</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="showCreateFormDialog">スタッフ追加</button>
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right uk-overflow-auto">
			<table id="staff_table" class="uk-table uk-table-expand uk-table-striped">
				<thead>
				<tr>
					<th>NO.</th>
					<th>社員番号</th>
					<th>氏名</th>
					<th>表示名</th>
					<th>{{ isLoginShopAdmin ? '氏名・表示名・PW変更' : '氏名・表示名変更' }}</th>
					<th>役割</th>
					<th>スキル属性</th>
					<th>管理者</th>
					<th>更新日</th>
					<th>操作</th>
					<th>削除</th>
				</tr>
				</thead>
				<tbody class="tbody">
				<template v-for="(staff, index) in staffs">
					<tr class="row data_row" :key="index" :data-id="staff.id">
						<td>{{ staff.id }}</td>
						<td>{{ staff.staff_number }}</td>
						<td>{{ staff.name }}</td>
						<td>{{ staff.display_name }}</td>
						<td>
							<button class="uk-button uk-button-default" @click="showEditStaffDialog(staff.id)">{{ isLoginShopAdmin ? '氏名・表示名・PW変更' : '氏名・表示名変更' }}</button>
						</td>
						<td><span class="uk-button uk-button-default" @click="showEditStaffShopJobPositionDialog(staff.id)">設定</span></td>
						<td><span class="uk-button uk-button-default" @click="showEditStaffShopSkillAttributeDialog(staff.id)">設定</span></td>
						<template v-if="current_staff.is_admin == true && current_staff.id == staff.id">
							<td><input class="uk-checkbox" name="is_admin" type="checkbox" checked disabled></td>
						</template>
						<template v-else-if="staff.staff_number == staff.shop.admin_staff_number">
							<td><input class="uk-checkbox" name="is_admin" type="checkbox" checked disabled></td>
						</template>
						<template v-else-if="staff.is_admin == true">
							<td><input class="uk-checkbox" name="is_admin" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="is_admin" type="checkbox"></td>
						</template>
						<td>{{ staff.updated_at | moment }}</td>
						<td class="data_row_handle">&#8645;</td>
						<td><span class="uk-icon-button" uk-icon="trash" @click="deleteStaff(staff.id)"></span></td>
					</tr>
				</template>
				<tr class="row">
					<td>
						<button class="uk-button uk-button-default" @click="showCreateFormDialog">+</button>
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				</tbody>
			</table>
		</div>
		<div class="uk-container uk-container-expand uk-margin-small-bottom">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="saveEditStaff">保存</button>
			</div>
		</div>
		<!--/ Main -->
		<!-- CreateFormDialog -->
		<div id="create_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body" style="width: 700px;">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="create_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin">
							<label class="uk-form-label" for="create_form_staff_number">社員番号 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_staff_number" name="staff_number" type="text" placeholder="社員番号を入力してください" required maxlength="20">
								<template v-if="typeof this.createFormState.errors.staff_number != undefined">
									<template v-for="(error,index) in this.createFormState.errors.staff_number">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="create_form_name">氏名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_name" name="name" type="text" placeholder="氏名を入力してください" required maxlength="20">
								<template v-if="typeof this.createFormState.errors.name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="create_form_display_name">表示名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_display_name" name="display_name" type="text" placeholder="表示名を入力してください" required maxlength="8">
								<template v-if="typeof this.createFormState.errors.display_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.display_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="create_form_password">初期パスワード(必須)(4桁以上英数)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_password" name="password" type="text" placeholder="初期パスワードを入力してください" required maxlength="16" @input="onInputPassword">
								<template v-if="typeof this.createFormState.errors.password != undefined">
									<template v-for="(error,index) in this.createFormState.errors.password">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
							<p class="uk-form-label" style="margin: 0 0 1em;">※初回ログイン時にパスワード変更が必要です。</p>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveCreateForm">追加</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ CreateFormDialog -->
		<!-- EditStaffJobPositionDialog -->
		<div id="edit_staff_shop_job_position_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">役割設定</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_staff_shop_job_position_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_staff_job_position_form">
					<div class="uk-grid uk-margin-bottom" uk-grid>
						<template v-for="(shop_job_position,index) in shop_job_positions">
							<label class="uk-width-1-3" :key="index">
								<input class="uk-checkbox uk-margin-small-right" name="shop_job_position" type="checkbox" :value="shop_job_position.id" :key="index">
								{{ shop_job_position.display_name }}
							</label>
						</template>
					</div>
					<button type="button" class="uk-width-1-1@l uk-button uk-button-primary" @click="saveEditStaffShopJobPositionDialog">保存</button>
				</form>
			</div>
		</div>
		<!--/ EditStaffJobPositionDialog -->

		<!-- EditStaffJobPositionDialog -->
		<div id="edit_staff_shop_skill_attribute_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">スキル設定</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_staff_shop_skill_attribute_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_staff_skill_attribute_form">
					<div class="uk-grid uk-margin-bottom" uk-grid>
						<template v-for="(shop_skill_attribute,index) in shop_skill_attributes">
							<label class="uk-width-1-3" :key="index">
								<input class="uk-checkbox uk-margin-small-right" name="shop_skill_attribute" type="checkbox" :value="shop_skill_attribute.id" :key="index">
								{{ shop_skill_attribute.skill_attribute.name }}
							</label>
						</template>
					</div>
					<button type="button" class="uk-width-1-1@l uk-button uk-button-primary" @click="saveEditStaffShopSkillAttributeDialog">保存</button>
				</form>
			</div>
		</div>
		<!--/ EditStaffJobPositionDialog -->

		<!-- EditStaffDialog -->
		<div id="edit_staff_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">編集</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_staff_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_staff_form">
					<div class="uk-margin">
						<label class="uk-form-label" for="edit_form_name">氏名 (必須)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="edit_form_name" name="name" type="text" placeholder="氏名を入力してください" required maxlength="20">
							<template v-if="typeof this.createFormState.errors.name != undefined">
								<template v-for="(error,index) in this.createFormState.errors.name">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="edit_form_display_name">表示名 (必須)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="edit_form_display_name" name="display_name" type="text" placeholder="表示名を入力してください" required maxlength="8">
							<template v-if="typeof this.createFormState.errors.display_name != undefined">
								<template v-for="(error,index) in this.createFormState.errors.display_name">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<template v-if="isLoginShopAdmin">
						<template v-if="editIsShopAdminStaff">
							<div class="uk-margin">
								<p class="uk-margin-remove">※管理者IDのため、パスワードを表示、変更できません。</p>
							</div>
						</template>
						<template v-else>
							<div class="uk-margin">
								<label class="uk-form-label">現在のパスワード</label>
								<div class="uk-form-controls">
									<p class="uk-margin-remove" id="edit_form_current_password">{{ editCurrentPasswordDisplay }}</p>
								</div>
							</div>
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_form_password">パスワード(リセットする場合は入力してください)(4桁以上英数)</label>
								<p class="uk-form-label uk-margin-remove">※リセット後初回ログイン時にパスワード変更が必要です。</p>
								<div class="uk-form-controls">
									<input class="uk-input" id="edit_form_password" name="password" type="text" placeholder="パスワードを入力してください" maxlength="16" @input="onInputPassword">
									<template v-if="typeof this.createFormState.errors.password != undefined">
										<template v-for="(error,index) in this.createFormState.errors.password">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</template>
					</template>
					<button type="button" class="uk-width-1-1@l uk-button uk-button-primary" @click="saveEditStaffDialog">保存</button>
				</form>
			</div>
		</div>
		<!--/ EditStaffJobPositionDialog -->

	</div>
</template>

<script>
	import RoleService from '@/services/RoleService'
	import Staff from '@/api/Staff'
	import StaffAuth from '@/api/StaffAuth'
	import Role from '@/api/Role'
	import ShopJobPosition from '@/api/ShopJobPosition'
	import StaffShopJobPosition from '@/api/StaffShopJobPosition'
	import StaffShopSkillAttribute from '@/api/StaffShopSkillAttribute'
	import ShopSkillAttribute from '@/api/ShopSkillAttribute'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import Sortable from 'sortablejs'

	export default {
		name: 'ShopStaffMasterPage',
		comments: [],
		data () {
			return {
				need_confirm_alert: false,
				createFormState: {
					errors: []
				},
				staffs: [],
				shop_job_positions: [],
				shop_skill_attributes: [],
				current_staff: null,
				editCurrentPasswordDisplay: '',
				editIsShopAdminStaff: false
			}
		},
		computed: {
			isLoginShopAdmin () { // ログインアカウントが所属店舗の店舗管理者か
				let staff = this.current_staff

				return staff != null && staff.shop != null && staff.staff_number == staff.shop.admin_staff_number
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			onInputPassword (event) {
				if (event.target.value.indexOf(' ') !== -1) {
					alert('パスワードに空白は含める事ができません')
					$(event.target).val('')
				}
			},
			showEditStaffDialog (id) {
				let self = this

				self.createFormState.errors = []

				$('#edit_staff_dialog').data('id', id)

				let params = new URLSearchParams()
				params.append('id', id)

				if (self.isLoginShopAdmin) {
					params.append('q_with_password', true)
				}

				Staff.one(params).then(function (response) {
					let data = response.data.data

					self.editIsShopAdminStaff = data.shop != null && data.shop.status == 0 && data.staff_number == data.shop.admin_staff_number

					$('#edit_form_name').val(data.name)
					$('#edit_form_display_name').val(data.display_name)

					if (self.isLoginShopAdmin && self.editIsShopAdminStaff == false) {
						$('#edit_form_password').val('')
						self.editCurrentPasswordDisplay = data.is_admin_setting ? data.password : '・・・・・・'
					}

					UIkit.modal($('#edit_staff_dialog'), {container: '#app div', bgClose: false}).show()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			saveEditStaffDialog () {
				let self = this

				let id = $('#edit_staff_dialog').data('id')
				let password = (self.isLoginShopAdmin && !self.editIsShopAdminStaff) ? $('#edit_form_password').val() : ''

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('name', $('#edit_form_name').val())
				params.append('display_name', $('#edit_form_display_name').val())

				if (password !== '') {
					params.append('password', password)
				}

				Staff.update(params).then(function (response) {
					alert('保存完了')
					location.reload()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/shop')
						location.reload()
					}
				} else {
					this.$router.push('/shop')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			moveDialogs () {
				$('#create_form_dialog').appendTo('body')
				$('#edit_staff_shop_job_position_dialog').appendTo('body')
				$('#edit_staff_shop_skill_attribute_dialog').appendTo('body')
			},
			bulkCheckAction () {
				let checked = $('#bulk_check_action').prop('checked')
				$('#staff_table tbody .data_row [name="status"]').prop('checked', checked)
				$('#staff_table tbody .data_row').addClass('data_row_before_save')
			},
			saveEditStaffShopSkillAttributeDialog () {
				let self = this
				let staff_id = $('#edit_staff_shop_skill_attribute_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', staff_id)

				Staff.one(params).then(function (response) {
					let staff = response.data.data

					let params = new URLSearchParams()
					params.append('staff_id', staff.id)

					StaffShopSkillAttribute.delete(params).then(function (response) {
						self.need_confirm_alert = false

						$('#edit_staff_shop_skill_attribute_dialog input[type="checkbox"]:checked').each(function () {
							let params = new URLSearchParams()
							params.append('staff_id', staff.id)
							params.append('shop_skill_attribute_id', $(this).val())

							StaffShopSkillAttribute.create(params).then(function (response) {
								self.need_confirm_alert = false
							})
						})
					})

					alert('保存完了')
					UIkit.modal($('#edit_staff_shop_skill_attribute_dialog')).hide()
				})
			},
			showEditStaffShopSkillAttributeDialog (id) {
				$('#edit_staff_shop_skill_attribute_dialog').data('id', id)
				$('#edit_staff_shop_skill_attribute_dialog input[type="checkbox"]').prop('checked', false)

				let params = new URLSearchParams()
				params.append('staff_id', id)
				params.append('status', 0)

				StaffShopSkillAttribute.all(params).then(function (response) {
					response.data.data.forEach(function (value) {
						$('#edit_staff_shop_skill_attribute_dialog input[value="' + value.shop_skill_attribute_id + '"]').prop('checked', true)
					})

					UIkit.modal($('#edit_staff_shop_skill_attribute_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			saveEditStaffShopJobPositionDialog () {
				this.need_confirm_alert = false

				let self = this
				let staff_id = $('#edit_staff_shop_job_position_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', staff_id)

				Staff.one(params).then(function (response) {
					let staff = response.data.data

					let params = new URLSearchParams()
					params.append('staff_id', staff.id)

					StaffShopJobPosition.delete(params).then(function (response) {
						$('#edit_staff_shop_job_position_dialog input[type="checkbox"]:checked').each(function () {
							let params = new URLSearchParams()
							params.append('staff_id', staff.id)
							params.append('shop_job_position_id', $(this).val())

							StaffShopJobPosition.create(params).then(function (response) {
								self.need_confirm_alert = false
							})
						})
					})

					alert('保存完了')
					UIkit.modal($('#edit_staff_shop_job_position_dialog')).hide()
				})
			},
			showEditStaffShopJobPositionDialog (id) {
				$('#edit_staff_shop_job_position_dialog').data('id', id)
				$('#edit_staff_shop_job_position_dialog input[type="checkbox"]').prop('checked', false)

				let params = new URLSearchParams()
				params.append('staff_id', id)

				StaffShopJobPosition.all(params).then(function (response) {
					response.data.data.forEach(function (value) {
						$('#edit_staff_shop_job_position_dialog input[value="' + value.shop_job_position_id + '"]').prop('checked', true)
					})

					UIkit.modal($('#edit_staff_shop_job_position_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			deleteStaff (id) {
				let self = this
				let answer = window.confirm('本当に削除しますか？')

				if (answer) {
					let params = new URLSearchParams()
					params.append('id', id)

					Staff.can_delete(params).then(function (response) {
						if (response.data.data) {
							Staff.delete(params).then(function (response) {
								location.reload()
							})
						} else {
							alert('このスタッフは削除できません')
						}
					})
				}
			},
			saveEditStaff () {
				let length = $('#staff_table .data_row_before_save').length

				$('#staff_table .data_row').each(function (i) {
					let index = i
					let order_by = i

					let id = $(this).data('id')
					let is_admin = false

					if ($(this).find('[name="is_admin"]').prop('checked')) {
						is_admin = true
					}

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('is_admin', is_admin)
					params.append('order_by', order_by)

					Staff.update(params).then(function () {
						if (i + 1 == length) {
							alert('保存完了')
							location.reload()
						}
					})
				})
			},
			saveCreateForm () { // ダイアログ保存
				let self = this

				StaffAuth.current().then(function (response) {
					let staff = response.data.data

					let staff_number = $('#create_form [name="staff_number"]').val()
					let name = $('#create_form [name="name"]').val()
					let display_name = $('#create_form [name="display_name"]').val()
					let password = $('#create_form [name="password"]').val()
					let is_admin = false
					let order_by = 999

					let params = new URLSearchParams()
					params.append('staff_number', staff_number)
					params.append('name', name)
					params.append('display_name', display_name)
					if (password != null) {
						params.append('password', password)
					}
					params.append('is_admin', is_admin)
					params.append('shop_id', staff.shop_id)
					params.append('order_by', order_by)

					Staff.create(params).then(function (response) {
						alert('保存完了')
						location.reload()
					}).catch(function (error) {
						self.createFormState.errors = error.response.data.errors
					})
				})
			},
			showCreateFormDialog () { // ダイアログ表示
				this.createFormState.errors = []

				UIkit.modal($('#create_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			checkRoleRedirect () { // 権限が無い場合はリダイレクト
				let self = this

				RoleService.isAdminStaff().then(function (value) {
					if (value == false) {
						self.$router.push('/staff/login')
					}
				})

				StaffAuth.current().then(function (response) {
					let staff = response.data.data

					if (staff == null) { // ログインしていない場合
						self.$router.push('/staff/login')
					}

					if (self.$route.params.shop_id != response.data.data.shop_id) { // スタッフの所属店舗が一致しない場合
						self.$router.push('/staff/login')
					}
				})
			},
			loadShopSkillAttributes () {
				let self = this

				StaffAuth.current().then(function (response) {
					return response.data.data
				}).then(function (staff) {
					let params = new URLSearchParams()
					params.append('shop_id', staff.shop_id)
					params.append('status', 0)

					ShopSkillAttribute.all(params).then(function (response) {
						self.shop_skill_attributes = response.data.data
					})
				})
			},
			loadShopJobPositions () {
				let self = this

				StaffAuth.current().then(function (response) {
					return response.data.data
				}).then(function (staff) {
					let params = new URLSearchParams()
					params.append('shop_id', staff.shop_id)
					params.append('status', 0)

					ShopJobPosition.all(params).then(function (response) {
						self.shop_job_positions = response.data.data
					})
				})
			},
			loadStaffs () { // スタッフ情報を取得する
				let self = this

				StaffAuth.current().then(function (response) {
					self.current_staff = response.data.data
					return response.data.data
				}).then(function (staff) {
					let params = new URLSearchParams()
					params.append('shop_id', staff.shop_id)

					Staff.all(params).then(function (response) {
						self.staffs = response.data.data
					})
				})
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				$(document).on('change', '#staff_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}
				})
			}
		},
		created () {
		},
		beforeMount () {
		},
		mounted () {
			this.loadStaffs() // スタッフ情報を取得
			this.registerDataChangeEvent() // データ変更に関するイベント登録
			this.loadShopJobPositions()
			this.loadShopSkillAttributes()
			this.moveDialogs()

			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data
			})

			$('#create_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#create_form_dialog')).hide()
				}
			})

			$('#edit_staff_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_staff_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_staff_dialog')).hide()
				}
			})

			$('#edit_staff_shop_job_position_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_staff_shop_job_position_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_staff_shop_job_position_dialog')).hide()
				}
			})

			$('#edit_staff_shop_skill_attribute_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_staff_shop_skill_attribute_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_staff_shop_skill_attribute_dialog')).hide()
				}
			})

			$('#create_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_staff_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_staff_shop_job_position_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_staff_shop_skill_attribute_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			Sortable.create($('#staff_table .tbody')[0], {
				handle: '.data_row_handle',
				draggable: '.data_row',
				dragoverBubble: true,
				onEnd: function (event) {
					$(event.item).addClass('data_row_before_save')
				},
				onMove: function (event) {
					$(event.item).addClass('data_row_before_save')
				}
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#create_form_dialog {
		@media (min-width: 960px) {
			.uk-form-label {
				width: 300px;
				white-space: nowrap;
			}

			.uk-form-controls {
				margin-left: 300px;
			}
		}

		.uk-form-controls .uk-input {
			width: 100%;
			box-sizing: border-box;
		}
	}

	#staff_table {
		width: 100%;
		overflow-x: auto;

		thead {
			tr {
				th {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
					white-space: nowrap;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
					white-space: nowrap;

					&:focus {
						background: #FFF;
					}
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/ShopStaffMasterPage.vue